import { createStyles, makeStyles } from '@material-ui/core/styles'
import { color } from 'src/color/color'

export const useStyles = makeStyles(() => createStyles({
  root: ({ hasBackground }: { hasBackground: boolean }) => ({
    background: hasBackground ? color('white') : 'transparent',
  }),
}))
